import { useEffect, useRef, useState } from 'react';

import produce from 'immer';

const useObjectiveTablePagination = ({
  rowsPerPageOptions = [10, 20, 30],
  defaultRowsPerPage = 10,
  initialPage = 0,
}) => {
  const [allData, setAllData] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
  const [pageNumber, setPageNumber] = useState(initialPage);

  const allDataRef = useRef(allData);

  useEffect(() => {
    allDataRef.current = allData;
  }, [allData]);

  const setData = (data, index) => {
    /*
            Using produce because we're inserting/appending into 
            array of objects and doing it in immutable way is a challenge,
            else the re-render won't happen
    */
    const updatedDataArray = produce(allDataRef.current, (draft) => {
      const firstHalf = draft.slice(0, pageNumber * rowsPerPage);
      const secondHalf = draft.slice(pageNumber * rowsPerPage + rowsPerPage);

      if (!firstHalf.length && !secondHalf.length && data && !Number.isNaN(index)) {
        const updateData = [...draft];
        updateData[index] = data[index];
        return [...firstHalf, ...updateData, ...secondHalf];
      }
      return [...firstHalf, ...data, ...secondHalf];
    });
    allDataRef.current = updatedDataArray;
    setAllData(updatedDataArray);
  };
  const slicedData = allData ? allData.slice(pageNumber * rowsPerPage, pageNumber * rowsPerPage + rowsPerPage) : null;

  const updateRowDataModifiedForArray = (newObjects = []) => {
    const latestSlicedData = allDataRef
      ? allDataRef.current.slice(pageNumber * rowsPerPage, pageNumber * rowsPerPage + rowsPerPage)
      : null;
    const updatedDataArray = produce(latestSlicedData, (draft) => {
      newObjects.forEach(({ index, newObj }) => {
        draft[index] = newObj;
      });
    });

    setData(updatedDataArray);
  };

  const addNewObjective = (newObjects = []) => {
    const latestSlicedData = allDataRef
      ? allDataRef.current.slice(pageNumber * rowsPerPage, pageNumber * rowsPerPage + rowsPerPage)
      : null;
    // const updatedDataArray = produce(latestSlicedData, draft => {
    //   draft = [...newObjects];
    // });

    setData(newObjects);
  };

  useEffect(() => {
    setPageNumber(0);
  }, [rowsPerPage]);

  return {
    rowsPerPageOptions,
    rowsPerPage,
    pageNumber,
    allData,
    data: slicedData,
    dataCount: allData ? allData.length : 0,
    setPageNumber,
    setRowsPerPage,
    setData,
    setAllData: (data) => {
      setAllData([...data]);
      setPageNumber(0);
    },
    updateRowDataModifiedForArray,
    addNewObjective,
  };
};

export default useObjectiveTablePagination;
